import { ReactElement } from 'react';

import { FormControlLabelProps, IconProps, InputProps } from '@rbilabs/universal-components';

import { LogUserErrorSeverity } from 'hooks/log-user-error-message';

export interface TextInputProps extends InputProps {
  alertMessage?: string;
  label?: string;
  hintMessage?: string;
  errorMessage?: string;
  required?: boolean;
  maxLength?: number;
  endIcon?: ReactElement<IconProps> | null;
  labelProps?: FormControlLabelProps;
  logUserErrorSeverity?: LogUserErrorSeverity;
  noMargin?: boolean;
}
